import Layout from '../components/layout';
import React from 'react';
import SEO from '../components/seo';
import heroImage from '../images/feature-article/seroja-roof-repairs.jpg';
import image01 from '../images/feature-article/seroja-impact.jpg';
import image02 from '../images/feature-article/seroja-commissioner-press-conference.jpg';

const title = 'Tropical Cyclone Seroja';
const intro = '';
// const heroImage = '../images/feature-article/seroja-roof-repairs.jpg';
const image01Caption = "Seroja's impact";
const image02Caption = 'FES Commissioner Darren Klemm speaking at a Seroja press conference in Kalbarri';

const FeatureArticle = () => {
    return (
        <Layout headerTitle={title} headerIntro={intro} headerImage={heroImage} showCTA={false}>
            <SEO title={title} />
            <div className="feature-article">
                <div className="o-container o-container--narrow">
                    <div className="o-section o-section--sm">
                        <h2>It has been almost 50 years since we have seen anything like it.</h2>

                        <p>
                            On 11 April 2021 Tropical Cyclone Seroja (Seroja) crossed the coast just south of Kalbarri, bringing damaging
                            wind gusts of up to 170km/hr and heavy rainfall. Making landfall at 8pm, Seroja was declared a Level 3 incident
                            following initial reports of extensive damage including a widespread loss of power and telecommunications.
                        </p>
                        <p>
                            Prior forecasts of Seroja’s predicted path and intensity informed a pre-emptive multiagency response, that
                            included sending emergency service responders to the regions under threat. We were ready in place to help
                            communities prepare for Seroja’s impact and support them immediately in its aftermath.
                        </p>
                        <p>
                            To keep communities updated with the latest information, a wide variety of media was used. We released 129
                            community safety alerts and warnings on Emergency WA, regularly posted on digital platforms and social media
                            channels, held live interviews on TV and radio and held joint press conferences with the Bureau of Meteorology.
                        </p>
                        <p>
                            Between 7 and 14 April over 167,800 users accessed Emergency WA, generating over 508,000 page views for
                            emergency information on the cyclone. Of particular note, within a single hour before Seroja made landfall,
                            12,243 users accessed Emergency WA and 2,036 calls were received by 13 DFES.
                        </p>
                        <p>
                            Influenced by a rare weather phenomenon known as the Fujiwhara Effect (when two cyclone systems interact),
                            Seroja devastated many coastal and inland properties and public infrastructure. As it tracked inland, it
                            continued to batter communities in 16 local governments across an area of more than 133,000km<sup>2</sup>
                        </p>
                    </div>
                </div>

                <div className="o-container o-container">
                    <div className="feature-article__image-container">
                        <img src={image02} alt="" />
                    </div>
                    <p className="feature-article__image-caption">{image02Caption}</p>
                </div>

                <div className="o-container o-container--narrow">
                    <div className="o-section o-section--sm">
                        <p>
                            Immediately post impact, more than 145 career and volunteer emergency services responders from Perth were sent
                            to Geraldton and Kalbarri to support the communities. Local and deployed responders completed initial
                            assessments of the structural devastation and threat to lives amid downed power lines and hazardous waste
                            materials, a risk to both the community and responders. To help manage the risks, a series of ‘Emergency
                            Situation’ declarations were made across the affected local governments.
                        </p>
                        <p>
                            Once contaminated material was identified among the debris, representatives from the Department of Water and
                            Environmental Regulation joined our asbestos risk management taskforce. Even though atmospheric monitoring
                            determined the asbestos contamination risk as low, procedures were put in place to identify and secure debris to
                            manage any risk.
                        </p>
                        <p>
                            As part of the response and recovery phase, the Australian Government Crisis Coordination Centre provided
                            specialist officers and equipment from the Australian Defence Force Army and Royal Australian Air Force to
                            assist recovery efforts.
                        </p>
                        <p>
                            From 12 April, Rapid Damage Assessment (RDA) teams completed 3,228 RDAs across the incident area. Extensive
                            clean-up operations included 1,570 requests for assistance for damaged structures, flooding, downed trees and
                            debris. All requests were completed and closed.
                        </p>
                        <p>
                            On 19 April more than 100 career and volunteer emergency services responders arrived from Victoria, South
                            Australia, New South Wales and Queensland to assist and help manage fatigue. COVID‑19 restrictions in WA
                            unfortunately prevented the other states sending responders.
                        </p>
                        <p>
                            Thankfully, despite the widespread devastation, no lives were lost. Seroja’s impact will, however, be felt for
                            years to come.
                        </p>
                        <p>
                            Since the initial reports of extensive damage were received, our Disaster Recovery Funding Officers have worked
                            with Emergency Management Australia to secure recovery funding assistance for those affected. As a result, on 14
                            April 2021, Seroja became an eligible disaster event under the Australian Government Disaster Recovery Funding
                            Arrangements (DRFA) for the local government areas impacted.
                        </p>
                    </div>
                </div>

                <div className="o-container o-container">
                    <div className="feature-article__image-container">
                        <img src={image01} alt="" />
                    </div>
                    <p className="feature-article__image-caption">{image01Caption}</p>
                </div>

                <div className="o-container o-container--narrow">
                    <div className="o-section o-section--sm">
                        <p>
                            Our Director Risk, Capability and Analysis, Melissa Pexton, was appointed the State Recovery Controller on 15
                            April. She immediately established the State Recovery Coordination Group, made up of 23 agencies and partner
                            organisations. The State Recovery Controller and the SRCG are charged to ensure whole-of-government recovery
                            support is provided across social, built, economic and natural environments.
                        </p>
                        <p>
                            On 19 May further DRFA funding support was announced for five Community Recovery Officers, to support the
                            impacted local governments. Coordinated through Perth, the Recovery Officers will be in Morawa, Northampton,
                            Geraldton and Kalbarri, providing an invaluable on the ground presence. Their role is to identify community
                            recovery needs, conduct community development and engagement activities and prioritise human and social recovery
                            projects in consultation with the local governments.
                        </p>
                        <p>
                            Our Seroja State Recovery Operations team will continue to support the State Recovery Controller and SRCG
                            throughout the long term recovery efforts.
                        </p>
                        <p>
                            Current Seroja recovery program information can be found on the{' '}
                            <a href="https://www.dfes.wa.gov.au/emergencywa/recovery.html" target="_blank">
                                Emergency WA
                            </a>{' '}
                            website.
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default FeatureArticle;
